import { sortByKey } from '@semios/app-platform-common'
import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import type { TOptions } from 'components/MultiSelect/MultiSelect.types'
import { translate } from 'i18n/i18n'
import type { TBlock } from 'stores/fieldAssetStore/helperTypes'
import { getCropNameFromId } from 'utils/getCropNameFromId'

type TBlocksGroupedByCropPickerProps = {
  blocks: TOptions[]
  selectedBlocks: TOptions[]
  setSelectedBlocks: (selectedBlocks: TOptions[]) => void
} & Omit<Parameters<typeof MultiSelect>[0], 'data' | 'selectedData' | 'onChange'>

export const shapeBlocksToOptions = (blocks: TBlock[]): TOptions[] => {
  return blocks
    .map((block) => {
      const cropId = block.cropIds?.[0]
      const cropName = getCropNameFromId(cropId)

      return {
        id: String(block.blockId),
        label: block.name,
        value: block.blockId,
        group: cropName,
      }
    })
    .sort(sortByKey('label'))
}

export const BlocksGroupedByCropPicker = (props: TBlocksGroupedByCropPickerProps) => {
  const { blocks, selectedBlocks, setSelectedBlocks, ...rest } = props

  return (
    <MultiSelect
      {...rest}
      data={blocks}
      groupOptions
      sortGroups
      placeholder={translate.phrases.banyanApp('Select blocks')}
      selectedValueDecorator={(value, index) => {
        return index && index >= 2 ? `+ ${value}` : `${value}`
      }}
      selectedData={selectedBlocks}
      onChange={(blocks) => setSelectedBlocks(blocks)}
    />
  )
}
